import { useState } from "react";
import Input from "./Input";
import Select from "./select/Select";

const UrlInput = ({ value, onChange = () => {}, placeholder }) => {
  const [protocol, setProtocol] = useState("http://");

  const handleChange = (e) => {
    const fullUrl = `${protocol}${e.target.value}`;
    onChange(fullUrl);
  };

  const handleProtocolChange = (val) => {
    const newProtocol = val;
    setProtocol(newProtocol);

    const strippedUrl = (value || "").replace(/^https?:\/\//, "");
    onChange(`${newProtocol}${strippedUrl}`);
  };

  return (
    <div className="flex rounded-l-md overflow-hidden w-full">
      <div className="w-24">
        <Select
          dropdownData={[
            { name: "http://", value: "http://" },
            { name: "https://", value: "https://" },
          ]}
          selectedValue={protocol}
          onChange={handleProtocolChange}
          dropdownButtonClass={"rounded-r-none bg-slate-100"}
        />
      </div>

      <Input
        type="text"
        inputPlaceholder={placeholder || "mysite.com"}
        value={(value || "").replace(/^https?:\/\//, "")}
        onChange={handleChange}
        inputClasses="rounded-l-none flex-grow"
      />
    </div>
  );
};

export default UrlInput;
